import { LocalLocationType } from './local-location-type';

export class LocalLocationContainerLight {

  public id: string;
  public glid: string;
  public name: string;
  public type: LocalLocationType;
  public coordinatesValidated: boolean;

  static fromDto(data: any): LocalLocationContainerLight {
    const container = new LocalLocationContainerLight();

    if (!data) {
      return null;
    }

    container.id   = data.id;
    container.glid = data.glid;
    container.name = data.name;
    container.type = data.type;
    container.coordinatesValidated = data.coordinates_validated;

    return container;
  }

}
